/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourcePoolProviderType } from './resourcePoolProviderType';
import { ResourcePoolRequestStatusType } from './resourcePoolRequestStatusType';
import { ResourcePoolRequestOperationType } from './resourcePoolRequestOperationType';


export interface ResourcePoolEntrySpec { 
    /**
     * Org id
     */
    org_id: string;
    /**
     * Assigned Resource Id
     */
    assigned_resource_id?: string;
    operation: ResourcePoolRequestOperationType;
    provider_type: ResourcePoolProviderType;
    /**
     * Request id
     */
    request_id: string;
    request_spec: object;
    status: ResourcePoolRequestStatusType;
    /**
     * Task Id
     */
    task_id?: string;
    /**
     * Requested by
     */
    requested_by: string;
    /**
     * Creation Timestamp
     */
    creation_ts: Date;
    /**
     * Requested by
     */
    updated_by?: string;
    /**
     * Update Timestamp
     */
    updated_ts?: Date;
}
export namespace ResourcePoolEntrySpec {
}


